<template>
	<section class="show">
		<div class="show__items">
			<div
				class="show__items-track"
				ref="track"
				:style="{ transform: `translateX(${translateX}px)` }"
			>
				<router-link
					class="show__item"
					v-for="(product, index) in loopedProducts"
					:key="index + '-' + product.id"
					@mouseenter="pauseFlow"
					@mouseleave="resumeFlow"
					:to="{
						name: 'ProductListPage',
						params: { itemType: 'all' },
						query: { types: product.type.toLowerCase() },
					}"
				>
					<div class="show__image _ibg-contain">
						<img :src="imgDomain + product.img_url" />
					</div>
				</router-link>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'BrowseItems',
	data() {
		return {
			imgDomain: '',
			products: [],
			translateX: 0,
			speed: 1.5,
			paused: false,
			animationFrameId: null,
			setWidth: 0,
		};
	},
	mounted() {
		this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
		this.fetchProducts();
	},
	beforeUnmount() {
		if (this.animationFrameId) {
			cancelAnimationFrame(this.animationFrameId);
		}
	},
	computed: {
		loopedProducts() {
			if (!this.products.length) return [];
			return [...this.products, ...this.products];
		},
	},
	methods: {
		fetchProducts() {
			this.$http
				.get(process.env.VUE_APP_API + 'items/last-sold')
				.then((res) => {
					this.products = res.data.payload || [];
					this.$nextTick(() => {
						this.initMarquee();
					});
				})
				.catch((res) => {
					if (res.response?.status === 401) {
						this.openSignInModal && this.openSignInModal();
					}
				});
		},

		initMarquee() {
			const track = this.$refs.track;
			if (!track || !this.products.length) return;

			const totalWidth = track.scrollWidth;
			this.setWidth = totalWidth / 2;

			this.translateX = 0;

			if (this.animationFrameId) {
				cancelAnimationFrame(this.animationFrameId);
			}
			this.loop();
		},

		pauseFlow() {
			this.paused = true;
		},
		resumeFlow() {
			this.paused = false;
		},

		loop() {
			if (!this.paused) {
				this.translateX -= this.speed;

				if (Math.abs(this.translateX) >= this.setWidth) {
					this.translateX += this.setWidth;
				}
			}

			this.animationFrameId = requestAnimationFrame(this.loop);
		},
	},
};
</script>

<style scoped lang="scss">
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/fonts' as *;
@use '@/assets/styles/components/classes' as *;

.show {
	@include adaptiveValue('padding-top', 100, 25);
	@include adaptiveValue('padding-bottom', 200, 40);
	min-width: 0;

	@media (max-width: 410px) {
		margin-left: -10px;
		margin-right: -10px;
	}
	&__items {
		border-top: 1px solid var(--hint-color);
		border-bottom: 1px solid var(--hint-color);
		background-color: rgba(0, 0, 0, 0.8);
		overflow: hidden;
		min-width: 0;
		@media (max-width: $md3) {
			padding: 10px 0px;
		}
		@media (max-width: 410px) {
			margin-left: auto;
			margin-right: auto;
			max-width: 320px;
		}
	}

	&__items-track {
		display: flex;
		align-items: center;
		gap: 20px;
		will-change: transform;

		@media (max-width: $md2) {
			gap: 10px;
		}
	}

	&__item {
		background-color: transparent;
		cursor: pointer;
		flex: 0 0 14%;
		min-height: 150px;
		display: flex;
		align-items: center;
		justify-content: center;

		@media (max-width: $md2) {
			flex: 0 0 25%;
		}

		@media (max-width: 649.98px) {
			min-height: fit-content;
			flex: 0 0 30%;
		}
		@media (max-width: $md4) {
			flex: 0 0 40%;
		}
		position: relative;
		transform: scale(1);
		transition: transform 0.3s ease 0s;
		overflow: hidden;
		@media (any-hover: hover) {
			&:hover {
				transform: scale(1.1);
				&::before {
					opacity: 1;
				}
			}
		}
		&::before {
			opacity: 0;
			transition: opacity 0.3s ease 0s;
			content: '';
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			z-index: -1;
			background-image: url('@/assets/images/bg/yellow-blur.png');
			transform: scale(1);
			background-position: center center;
			background-repeat: no-repeat;
			background-size: contain;
		}
	}

	&__image {
		margin: auto;
		max-width: 135px;
		width: 100%;
		padding-bottom: 51%;
	}
}
</style>
